import Icon from 'components/base/Icon';
import { StyledHeader } from './Header.style';
import SettingsButton from '../settings/SettingsButton';

const Header = () => {
  return (
    <StyledHeader>
      <Icon name='Bulb' size='medium' color='shuttleGray' />
      Insights
      <SettingsButton />
    </StyledHeader>
  );
};

export default Header;
